var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"ghost-button"},[_vm._v("\n  "+_vm._s(_vm.blok.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }